const APPLICATION_FORM_URL = '/doctor-workplace/apply'

window.scrollToForm = () => {
    window.scrollTo({
        top: document.getElementById('apply-now').getBoundingClientRect().top + window.scrollY - 20,
        behavior: 'smooth'
    })
}

window.apply = () => {
    setErrorMessage(null)
    setSpinnerVisible()

    const data = new URLSearchParams()
    for (const param of new FormData(document.getElementById('applicationForm'))) {
        data.append(param[0], param[1])
    }

    fetch(APPLICATION_FORM_URL, {
        method: 'post',
        body: data,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                window.location = '/kalendars/success'

            } else {
                setErrorMessage(response.error ?? 'Notika kļūda pieteikuma izveidē. Rakstiet uz hd@medicloud.lv.')
            }
        })
        .catch(() => {
            setErrorMessage('Notika kļūda pieteikuma izveidē. Rakstiet uz hd@medicloud.lv!')
        })
        .finally(() => {
            setSpinnerVisible(false)
        })
}


// Parāda kļūdas paziņojumu zem pieteikšanās pogas
function setErrorMessage(message) {
    if (message) {
        document.getElementById('error-message').innerText = message
        document.getElementById('error-message').classList.remove('opacity-0')

    } else {
        document.getElementById('error-message').classList.add('opacity-0')
    }
}


// Parāda ielādes spineri zem pieteikšanās pogas
function setSpinnerVisible(visible = true) {
    if (visible) {
        document.getElementById('loading-spinner').classList.remove('opacity-0')

    } else {
        document.getElementById('loading-spinner').classList.add('opacity-0')
    }
}


/**
 * https://laravel.com/docs/11.x/vite#blade-processing-static-assets
 */
import.meta.glob([
    '../images/**',
])
